import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IrisWorkspaceType } from '../../../../data-access/setup/types/iris-workspace.type';
import { BoardType } from '../interfaces/helper.interface';

export const MakeChangeActions = createActionGroup({
  source: 'Change In Research',
  events: {
    'Load Workspace Types': props<{ workspaceTypeId: string }>(),
    'Load Workspace Types Success': props<{
      workspaceTypes: IrisWorkspaceType[];
    }>(),
    'Load Review Locations': emptyProps(),
    'Load Review Locations Success': props<{ reviewLocations: BoardType[] }>(),
    'Create Workspace': props<{ payload: any }>(),
    'Create Workspace Success': props<{ workspace: any }>(),
    'Load Sites': props<{
      field: string;
      pageIndex: number;
      pageSize: number;
    }>(),
    'Load Sites Success': props<{ sites: any }>(),
    'Store Study Id': props<{ study: string }>(),
    'Store Study Name': props<{ studyName: string }>(),
    'Store Workspace type': props<{ workspaceType: BoardType }>(),
    'Store Single Site': props<{ site: string }>(),
    'Clear all': emptyProps(),
    'Store Review Location Type': props<{ reviewLocationtype: string }>(),
    'Store Study Access': props<{ has_access: boolean }>(),
    'Set Total Sites': props<{ totalSites: number }>(),
    'Set Site Loaded': props<{ siteLoaded: boolean }>(),
  },
});
